import * as t from "io-ts";
import nullable from "./nullable";
export const financeT = t.strict({
    financeSystem: nullable(t.union([
        t.literal("E-CONOMIC"),
        t.literal("Business Central"),
        t.literal("Tripletex"),
        t.literal("PowerOffice"),
    ])),
    unitsOnInvoices: t.boolean,
});
export const financeUnitT = t.strict({
    id: t.string,
    name: t.string,
});
export const financeUnitsT = t.array(financeUnitT);
export const departmentT = t.strict({
    id: t.string,
    departmentNumber: nullable(t.number),
    number: nullable(t.string),
    name: t.string,
    deleted: t.boolean,
});
const customerGroupT = t.strict({
    name: t.string,
    customerGroupNumber: t.number,
});
export const customerGroupsT = t.array(customerGroupT);
export const departmentsT = t.array(departmentT);
export const economicProductGroupT = t.strict({
    id: t.string,
    name: t.string,
    number: t.string,
    teamIds: t.array(t.string),
});
export const economicProductGroupsT = t.array(economicProductGroupT);
//# sourceMappingURL=finance.js.map